import { BehaviorSubject, Subscription } from 'rxjs';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { SelectInputData } from '../../interfaces/select-input-data.interface';

@Component({
  selector: 'app-filter-sorter-options',
  templateUrl: './filter-sorter-options.component.html',
  styleUrls: ['./filter-sorter-options.component.scss']
})
/** @deprecated use app-filter-options instead */
export class FilterSorterOptionsComponent<T> implements OnInit, OnDestroy, OnChanges {
  @Input() label: string = '';
  @Input() options: SelectInputData<T>[] = [];
  @Input() resetOptions?: BehaviorSubject<boolean>;
  @Input() longerLabels = false;
  @Input() hideLabelWhenSelected = false;
  @Input() defaultOption: T | undefined = undefined;

  @Output() optionChanged = new EventEmitter<T>();

  public currentOption?: T;

  private subscription$ = new Subscription();

  constructor(public rwdService: RWDService) {}

  ngOnInit(): void {
    this.setFirstOption();
    if (this.resetOptions) {
      this.subscription$.add(
        this.resetOptions.subscribe((value) => {
          if (value) {
            this.setFirstOption();
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultOption && !changes.defaultOption.firstChange && this.defaultOption !== undefined) {
      // Keep UI in sync when parent updates selected sort externally (e.g. reset from badge).
      this.currentOption = this.defaultOption;
    }

    if (changes.options) {
      this.setFirstOption();
    }
  }

  onOptionChange() {
    this.optionChanged.emit(this.currentOption);
  }

  public get hasSelection(): boolean {
    return this.currentOption !== null && this.currentOption !== undefined;
  }

  private setFirstOption() {
    if (this.defaultOption !== undefined) {
      this.currentOption = this.defaultOption;
      this.onOptionChange();
    } else if (this.options.length > 0) {
      this.currentOption = this.options[0].value;
      this.onOptionChange();
    }
  }
}
